/**
* Tabbed Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tabbed Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'tabbed-featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.tabbed-featured-services__splide' ).length ) {
        $( '.tabbed-featured-services__splide' ).each( function( index, element ) {
          const splide = new Splide( $( element )[0], {
            perPage: 3,
            gap: '32px',
            pagination: false,
            rewind: true,
            breakpoints: {
              767: {
                perPage: 1,
              },
            },
          } );
          const bar = splide.root.querySelector( '.progress-bar' );

          splide.on( 'mounted move', function() {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          splide.mount( );
        } );
      }
      $( '.tabbed-featured-services' ).each( function() {
        const $mobileDropDown = $( '.mobile-dropdown' );
        $( '.dropdown-button' ).on( 'click', function() {
          const newText = $( this ).text();
          $mobileDropDown.text( newText );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tabbed-featured-services', COMPONENT );
} )( app );
